// 待测试 百度 添加title

export const pageTitle = (path) => {
    // TODO: 这里修改
    const defaultTitle = '大麦家商城_礼品批发_实用小礼品真实物流一件代发首选电商平台'
    const pathArr = {
        '/tool': {
            title: '猜你喜欢 手淘猜你喜欢流量 精准标签 提升店铺转化率 手淘首页推荐 淘宝补单 补单工具 大麦家礼品商城'
        },
        '/tool/foreign': {
            title: '洋淘秀卡首屏 洋淘买家秀卡首屏入口 洋淘秀补单入口 淘宝补单 补单工具 卡ifashion手淘入口 大麦家礼品商城'
        },
        '/tool/firstScreen': {
            title: '关键词卡首屏 卡首屏入口 关键词卡首屏 在线生成卡首屏二维码 淘宝补单 补单工具 在线生成卡首屏淘口令  大麦家礼品商城'
        },
        '/tool/similar': {
            title: '找相似入口 手淘找相似 淘宝找相似打标 淘宝补单 补单工具 在线生成找相似淘口令 找相似流量 大麦家礼品商城'
        },
        '/tool/goodShop': {
            title: '有好货 手淘有好货  在线生成有好货淘口令二维码 淘宝补单 补单工具 有好货流量 大麦家礼品商城'
        },
        '/tool/mirror': {
            title: '旺旺标签透视镜 旺旺验号 买家标签 数据验号 查旺旺号 淘宝补单 补单工具 查打标 查人群标签 买家透视镜 旺旺标签透视镜 大麦家礼品商城'
        },
    }
    // const mgHost = ['bailingniao'].some(item => location.host.indexOf(item) > -1)
    const mgHost = true

    if (pathArr[path]) {
        return mgHost ? pathArr[path].title.replace(/补单/g, '电商') : pathArr[path].title
    } else {
        return mgHost ? defaultTitle.replace(/补单/g, '电商') : defaultTitle
    }
}